module.exports = __webpack_public_path__ + "static/media/logo1.f0c059fa.png";